<lls-datagrid [options]="commentGridOptions" (gridInit)="getData()" (rowsSelected)="rowsSelected($event)" #commentsTable></lls-datagrid>
